function Counter(props){
    return(
        <div>
            <p>song {props.counter} out of {props.len}</p>
        </div>
    );
}

export default Counter;